import { OnboardingImportModal } from '@pages/onboarding';
import { Typography, Button } from '@ui/components';
import { useMutation } from '@tanstack/react-query';
import { resetOnboarding } from '@api/onboarding';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Routes } from '@shared/enums';
import { useState } from 'react';

export const OnboardingImportRemoval = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { mutate, isPending } = useMutation({
    mutationFn: resetOnboarding,
    onSuccess: () => {
      navigate(`../${Routes.ADD_VEHICLES}`);
    },
  });

  const [isImportModalOpen, setIsImportModalOpen] = useState(true);

  return (
    <section className="space-y-6">
      <Typography variant="h400" element="h1">
        {t('ONBOARDING.IMPORT_REMOVAL.TITLE')}
      </Typography>

      <Typography variant="paragraphLargeBook">
        {t('ONBOARDING.IMPORT_REMOVAL.DESCRIPTION')}
      </Typography>

      <OnboardingImportModal setOpen={setIsImportModalOpen} open={isImportModalOpen}>
        <Button disabled={isPending} variant="secondary" className="mb-4" size="large" wide>
          {t('ONBOARDING.IMPORT_REMOVAL.IMPORT_DATA')}
        </Button>
      </OnboardingImportModal>

      <Button
        onClick={() => mutate()}
        isLoading={isPending}
        disabled={isPending}
        className="px-0"
        variant="link"
      >
        {t('ONBOARDING.IMPORT_REMOVAL.ADD_MANUALLY')}
      </Button>
    </section>
  );
};
